module.exports = __webpack_public_path__ + "media/images/mailer-woman-interviewing-2-3ec3848f1405252ae5ed1885cdff90c8.png";